import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import leadsSaga from './leads/saga'
import leadsSycSaga from './leads-syc/saga'
import leadsCrmSaga from './leads-crm/saga'
import reportSaga from './reports/saga'

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    leadsSaga(),
    leadsSycSaga(),
    leadsCrmSaga(),
    reportSaga(),
  ]);
}
